import highcharts from 'highcharts';

// ============================================ 차트 툴팁 위치/크기 조정을 위한 하이차트 함수 Override 시작 =============================================== //
/* eslint-disable */
// jshint ignore: start
highcharts.wrap(highcharts.Pointer.prototype, 'normalize', function (proceed, e) {
  var e = proceed.call(this, e);

  try {
    var dataset = this.chart.container.parentElement.dataset;
    if (dataset.scaleX && dataset.scaleY) {
      e.chartX /= dataset.scaleX;
      e.chartY /= dataset.scaleY;
    }
  } catch (ex) {
    // ignore
  }

  return e;
});
highcharts.wrap(highcharts.Tooltip.prototype, 'refresh', function (proceed, pointOrPoints, mouseEvent) {
  proceed.call(this, pointOrPoints, mouseEvent);
  try {
    var dataset = this.chart.container.parentElement.dataset;
    if (dataset.scaleX && dataset.scaleY) {
      if (this.label.div) {
        this.label.div.style.transform = `scale(${1 / dataset.scaleX}, ${1 / dataset.scaleY})`;
      }
      else if (this.label.text.element) {
        this.label.text.element.style.transform = `scale(${1 / dataset.scaleX}, ${1 / dataset.scaleY})`;
      }
    }
  } catch (ex) {
    // ignore
  }
});
// jshint ignore:end
/* eslint-enable */
// ============================================ 차트 툴팁 위치/크기 조정을 위한 하이차트 함수 Override 끝 =============================================== //



// WEBPACK FOOTER //
// ./src/views/dashboard/js/highcharts-ex.js